import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-377c8696"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full flex flex-col shadow-card voucher-card rounded-2xl overflow-hidden" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-image voucher-image" }, null, -1))
const _hoisted_3 = { class: "mx-8 mb-8 text-gray-4" }
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = { class: "text-xl font-medium text-gray-5" }
const _hoisted_6 = { class: "text-sm whitespace-nowrap overflow-hidden" }
const _hoisted_7 = { class: "leading-relaxed" }
const _hoisted_8 = { class: "leading-relaxed" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_10 = { class: "flex justify-between align-middle" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "uppercase font-medium tracking-wider text-gray-6" }, "Total", -1))
const _hoisted_12 = { class: "font-medium text-base-color" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "0",
  height: "0"
}, [
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", {
      id: "voucher-shape",
      clipPathUnits: "objectBoundingBox"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        transform: "scale(0.00313, 0.0047)",
        d: "M0 14C0 6.268 6.26801 0 14 0H306C313.732 0 320 6.26801 320 14V159.662C320 165.843 315.937 171.308 309.995 173.008C179.57 210.329 53.2058 210.752 13.0966 209.764C5.68569 209.582 0 203.495 0 196.082V14Z"
      })
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.voucher.description), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.voucher.info.address + ". " + _ctx.voucher.info.commune), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.voucher.entries, (entry) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "text-sm flex justify-between align-middle",
            key: entry.description
          }, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(entry.description), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.formatCurrency(entry.amount)), 1)
          ]))
        }), 128)),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.totalValue), 1)
        ])
      ]),
      _createElementVNode("div", {
        class: "h-16 pt-4 leading-8 text-xl font-book text-center align-middle select-none border-none shadow-button transition-colors duration-500 rounded-md cursor-pointer bg-base-color",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.payVoucher && _ctx.payVoucher(...args)))
      }, " Pagar ")
    ]),
    _hoisted_13
  ], 64))
}